// @flow
import Header from './Header';
export default Header;



// WEBPACK FOOTER //
// ./src/components/Layout/components/Header/index.js